export default "__VITE_ASSET__f27cd98e__"